module.exports = __webpack_public_path__ + "img/photo-long-5.2e67f68f.jpg";